import {
  SET_EXPAND_ALL,
  SET_FACILITIES,
  SET_FACILITIES_LOADING,
} from '../actions/actionTypes';

const defaultState = {
  facilities: { isLoading: false, data: [] },
  expandAllRows: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_FACILITIES:
      return {
        ...state,
        facilities: { isLoading: false, data: action.payload },
      };
    case SET_FACILITIES_LOADING:
      return { ...state, facilities: { ...state.facilities, isLoading: true } };
    case SET_EXPAND_ALL:
      return { ...state, expandAllRows: action.payload };
    default:
      return state;
  }
};
